// extracted by mini-css-extract-plugin
export default {"card":"experience-card_card__w9uxw","content":"experience-card_content__LxzUj","collapsedEnd":"experience-card_collapsedEnd__nBP8f","button":"experience-card_button__Su+RY"};